<template>

    <v-container class="fill-height" style="display: block;" fluid>

        <v-window v-model="windowPage" style="width: 100%;" touchless>

            <v-window-item :key="0">
                <template v-if="showAlarmCorrelationsList">
                    <alarm-correlations-list :alarmCorrelationsList="alarmCorrelationsList" :lockSave="lockSave" @edit="editAlarmCorrelation" @delete="deleteAlarmCorrelationClick" @moveToClick="moveToClick" @clone="cloneCorrelation"></alarm-correlations-list>
                    <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewAlarmCorrelation" :disabled="lockSave">New</v-btn>
                    <v-btn color="#c42111" class="mt-3 mr-3" @click="saveAlarmCorrelationsRanks" :disabled="lockSave || !$store.state.isDirty">
                        Save
                        <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                            <template v-slot:activator="{ on }">
                                <v-icon class="is-dirty-save-button-icon" v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>Pending Changes</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-window-item>

            <v-window-item :key="1">
                <alarm-correlations-edit v-if="windowPage == 1" :alarmCorrelation="selectedAlarmCorrelation" :alarmCorrelationsResources="alarmCorrelationsResources" :lockSave="lockSave" @save="saveAlarmCorrelation" @cancel="cancelClick"></alarm-correlations-edit>
            </v-window-item>

        </v-window>

        <v-dialog v-model="showMoveTo" max-width="80%" width="425px" persistent v-if="showMoveTo">
            <grid-list-move-to :selectedItemRank="alarmCorrelationMoving.correlation_rank" :maxRank="alarmCorrelationsList.length" titleText="Move Alarm Correlation Rank" @cancel="showMoveTo = false" @ok="moveTo"></grid-list-move-to>
        </v-dialog>

    </v-container>

</template>

<script>
import AlarmCorrelationsList from "@/components/AlarmCorrelations/AlarmCorrelationsList";
import GridListMoveTo from "@/components/GridListMoveTo";
import AlarmCorrelationsEdit from "@/components/AlarmCorrelations/AlarmCorrelationsEdit";
export default {
    name: 'AlarmCorrelations',
    props: [],
    components: {
        AlarmCorrelationsList,
        GridListMoveTo,
        AlarmCorrelationsEdit
    },
    data: () => ({
        lockSave: false,
        windowPage: 0,
        alarmCorrelationsResources: null,
        showAlarmCorrelationsList: false,
        alarmCorrelationsList: [],
        selectedAlarmCorrelation: null,
        alarmCorrelationMoving: null,
        showMoveTo: false
    }),

    computed: {

    },

    methods: {
        getAlarmCorrelationsList: function() {
            this.showAlarmCorrelationsList = false;
            let route = (TELSA.apiHost + "alarmcorrelations/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.alarmCorrelationsList = result.alarm_correlations;
                this.alarmCorrelationsResources = result.alarm_correlations_resources;
                this.showAlarmCorrelationsList = true;
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
            });
        },

        addNewAlarmCorrelation: function() {
            this.selectedAlarmCorrelation = {
                correlation_id: 0,
                correlation_rank: this.alarmCorrelationsList.length + 1,
                correlation_name: "",
                alarm_office: null,
                alarm_location: null,
                alarm_locale: null,
                alarm_severity: null,
                alarm_description: null,
                alarm_service_affecting: false,
                active_starting: null,
                active_until: null,
                stop_if_matches: false,
                documentation: null,
                alarm_conditions: [],
                alarm_groupings: []
            };
            this.windowPage = 1;
        },

        editAlarmCorrelation: function(alarmCorrelation) {
            this.selectedAlarmCorrelation = JSON.parse(JSON.stringify(alarmCorrelation));
            this.windowPage = 1;
        },

        deleteAlarmCorrelationClick: function(alarmCorrelation) {
            this.$store.commit('showConfirmModal', {
                title: 'Confirm Delete',
                message: 'Are you sure you want to delete this alarm correlation?',
                type: 'delete',
                confirmAction: () => {this.deleteAlarmCorrelation(alarmCorrelation);}
            });
        },

        deleteAlarmCorrelation: function(alarmCorrelation) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "alarmcorrelations/delete");
            return this.$http.post(route, {args: {alarm_correlation_id: alarmCorrelation.correlation_id}}).then(response => {
                let result = response.body;
                this.selectedAlarmCorrelation = null;
                this.getAlarmCorrelationsList();
            });
        },

        saveAlarmCorrelation: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "alarmcorrelations/add");
            if(this.selectedAlarmCorrelation.correlation_id != 0) {
                route = (TELSA.apiHost + "alarmcorrelations/edit");
            }
            return this.$http.post(route, {args: {alarm_correlation: this.selectedAlarmCorrelation}}).then(response => {
                let result = response.body;
                this.windowPage = 0;
                this.selectedAlarmCorrelation = null;
                this.getAlarmCorrelationsList();
            });
        },

        saveAlarmCorrelationsRanks: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "alarmcorrelations/ranks");
            let alarmCorrelationRanks = this.alarmCorrelationsList.map(ac => {return {correlation_id: ac.correlation_id, correlation_rank: ac.correlation_rank}});
            return this.$http.post(route, {args: {alarm_correlations: alarmCorrelationRanks}}).then(response => {
                let result = response.body;
                this.selectedAlarmCorrelation = null;
                this.getAlarmCorrelationsList();
            });

        },

        cancelClick: function() {
            this.windowPage = 0;
            this.selectedAlarmCorrelation = null;
        },

        moveToClick: function(alarmCorrelation) {
            this.alarmCorrelationMoving = alarmCorrelation;
            this.showMoveTo = true;
        },

        moveTo: function(newRank) {
            // take it out, change rank, put it in new rank spot, recalc ranks
            this.alarmCorrelationsList.splice(this.alarmCorrelationsList.indexOf(this.alarmCorrelationMoving), 1);
            this.alarmCorrelationMoving.correlation_rank = newRank;
            this.alarmCorrelationsList.splice((newRank - 1), 0, this.alarmCorrelationMoving);
            for (let [idx, alarmCorrelation] of this.alarmCorrelationsList.entries()) {
                alarmCorrelation.correlation_rank = (idx + 1);
            }
            this.showMoveTo = false;
        },

        cloneCorrelation: function(alarmCorrelation) {
            let alarmCorrelationObj = JSON.parse(JSON.stringify(alarmCorrelation));
            alarmCorrelationObj.correlation_id = 0;
            alarmCorrelationObj.correlation_rank = this.alarmCorrelationsList.length + 1;
            this.selectedAlarmCorrelation = alarmCorrelationObj;
            this.windowPage = 1;
        },
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/alarm_correlations');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getAlarmCorrelationsList()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_correlations`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getAlarmCorrelationsList().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `Alarms Correlations is locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }

                // Check if they came here from alarms and want to create a new alarm condition(or perhaps alarm correlation) with prefilled alarm info
                // if(!lockOwner && this.$store.state.pagingRuleShortcut) {
                //     this.addNewPagingRule(this.$store.state.pagingRuleShortcut);
                //     this.$store.commit('setPagingRuleShortcut', null);
                // }
            });
        });




    },
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

</style>

    
